// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__2rIEn","title":"ClientCherryInfo_title__3xwSX","itemText":"ClientCherryInfo_itemText__3g2m9"};